module.exports = __webpack_public_path__ + "static/voice-aab35af647af1bc46363f3e470e3ce3c.webp";